import BlockAccordion from 'components/BlockAccordion';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import type { HTMLString } from 'types';
import { getEditorMargin } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';

interface Item {
	content?: Field<HTMLString>;
	heading?: Field<string>;
}

interface Props extends SitecoreBlockProps {
	fields?: {
		heading?: Field<string>;
		items?: Item[];
	};
}

export default function AccordionBlock({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const items = filterTruthy(
		fields.items?.map((item) => ({
			content: item.content?.value,
			heading: item.heading?.value,
		})),
		'content',
		'heading',
	);

	if (items.length === 0) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="Accordion"
				description="Requires at least one item that has a heading and content"
			/>
		);
	}

	return (
		<BlockAccordion
			className={getEditorMargin(params)}
			items={items}
			heading={fields.heading}
			headingLevel={params?.heading}
		/>
	);
}
AccordionBlock.displayName = 'AccordionBlock';
